<template>
  <keyboard-shortcuts :show-shortcuts-obj="showShortcutsObj" :line-data-sets="lineDataSets" />
</template>

<script>
import KeyboardShortcuts from 'shared/components/KeyboardShortcuts/KeyboardShortcuts'
import {AppConfig} from '@/appConfig'

let lineDataSets = [
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'arrow-key', direction: 'right' },
          { type: 'arrow-key', direction: 'left' }
      ] }
    ],
    explanationText: 'מעבר בין ראשי תיבות',
    explanationTextEng: 'Skip between abbreviations'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'arrow-key', direction: 'down' },
          { type: 'arrow-key', direction: 'up' }
      ] }
    ],
    explanationText: 'בחירה מרשימת אפשרויות פיענוח',
    explanationTextEng: 'Choose from avialble expansion options'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'arrow-key', direction: 'down' },
          { type: 'arrow-key', direction: 'up' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' }
      ] }
    ],
    explanationText: 'מעבר בין שורות'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'arrow-key', direction: 'down' },
          { type: 'arrow-key', direction: 'up' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' },
          { type: 'plus' },
          { type: 'key', text: 'Ctrl' }
      ] }
    ],
    explanationText: 'מעבר בין פסקאות'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: 'E' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' }
      ] }
    ],
    explanationText: 'עריכת מילה',
    explanationTextEng: 'Edit word'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: 'T' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' }
      ] }
    ],
    explanationText: 'הצגה / הסתרה של ראשי תיבות מקוריים',
    explanationTextEng: 'Show / hide original abbreviations'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: 'A' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' }
      ] }
    ],
    explanationText: 'החל שינויים על כל הטקסט',
    explanationTextEng: 'Apply changes to entire text'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: 'C' },
          { type: 'plus' },
          { type: 'key', text: 'Ctrl' }
      ] }
    ],
    explanationText: 'העתקת טקסט',
    explanationTextEng: 'Copy text'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: 'D' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' }
      ] }
    ],
    explanationText: 'ייצוא קובץ',
    explanationTextEng: 'Download file'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: 'Z' },
          { type: 'plus' },
          { type: 'key', text: 'Ctrl' }
      ] }
    ],
    explanationText: 'ביטול פעולה',
    explanationTextEng: 'Undo operation'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: 'Y' },
          { type: 'plus' },
          { type: 'key', text: 'Ctrl' }
      ] }
    ],
    explanationText: 'שחזור פעולה',
    explanationTextEng: 'Redo operation'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: '+' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' }
      ] }
    ],
    explanationText: 'הגדלת טקסט',
    explanationTextEng: 'Increase font size'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: '-' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' }
      ] }
    ],
    explanationText: 'הקטנת טקסט',
    explanationTextEng: 'Decrease font size'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: 'Q' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' }
      ] }
    ],
    explanationText: 'הוספת אפשרות פיענוח למאגר האישי',
    explanationTextEng: 'Add expansion options to personal list'
  },
  {
    groupingItems: [
      { type: 'group', itemsOfGroup: [
          { type: 'key', text: 'X' },
          { type: 'plus' },
          { type: 'key', text: 'Shift' }
      ] }
    ],
    explanationText: 'סימון פיענוח כפגום',
    explanationTextEng: 'Mark expansion as irrelevant'
  }
]
if (AppConfig.NON_CONFIDENT_MARKING) lineDataSets.push({
  groupingItems: [
    { type: 'group', itemsOfGroup: [
      { type: 'key', text: 'S' },
      { type: 'plus' },
      { type: 'key', text: 'Shift' }
    ] }
  ],
  explanationText: 'הוספה והסרת סימון פיענוח מסופק',
  explanationTextEng: 'Toggle non-confident marking'
})
if (AppConfig.OFFER_DROPBOX) lineDataSets.push({
  groupingItems: [
    { type: 'group', itemsOfGroup: [
        { type: 'key', text: 'S' },
        { type: 'plus' },
        { type: 'key', text: 'Shift' },
        { type: 'plus' },
        { type: 'key', text: 'Ctrl' }                        
    ] }
  ],
  explanationText: 'שמירה בDropbox',
  explanationTextEng: 'Save to Dropbox'
})
lineDataSets.push({
  groupingItems: [
    { type: 'group', itemsOfGroup: [
        { type: 'key', text: 'Enter' },
        { type: 'plus' },
        { type: 'key', text: 'Ctrl' }
    ] }
  ],
  explanationText: 'החל ניקוד',
  explanationTextEng: 'Apply nikud'
})
lineDataSets.push({
  groupingItems: [
    { type: 'group', itemsOfGroup: [
        { type: 'key', text: 'N' },
        { type: 'plus' },
        { type: 'key', text: 'Alt' }
    ] }
  ],
  explanationText: 'טען טקסט חדש',
  explanationTextEng: 'Enter new text'
})

export default {
  name: 'KeyboardShortcutsContainer',
  props: ['showShortcutsObj'],
  components: {KeyboardShortcuts},
  data () {
    return {
      lineDataSets: lineDataSets
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    }  
  } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
